const selectors = {
  grid: '[data-grid]',
  gridItem: '[data-grid-item]',
  pagination: '[data-pagination]',
  progressViewed: '[data-pagination-viewed]',
  progressBar: '[data-progress-bar]',
  loadMoreButton: '[data-load-more]',
  loadNext: '[data-load-next]',
  loadPrev: '[data-load-prev]',
  sentinel: '[data-pagination-sentinel]',
  isNew: '.is-new',
};

const classes = {
  btnLoading: 'btn--loading',
  isNew: 'is-new',
  hide: 'hide',
};

const attributes = {
  resultsGrid: 'data-results-grid',
  loadNext: 'data-load-next',
  loadPrev: 'data-load-prev',
};

function initPagination(sectionID) {
  if (!sectionID) return;

  const grid = document.querySelector(selectors.grid);
  const pagination = document.querySelector(selectors.pagination);

  if (!grid || !pagination) return;

  const settingsData = pagination.dataset.settings || '{}';
  const settings = JSON.parse(settingsData);

  const progressViewedElem = document.querySelector(selectors.progressViewed);
  const progressBarElem = document.querySelector(selectors.progressBar);

  let responseBuffer = [];
  let requestPending = false;
  let productsViewedNo = 0;

  if (progressViewedElem) {
    productsViewedNo = parseInt(progressViewedElem.textContent, 10);
  }

  // Handle click on load more buttons (load next or load previous)
  const loadMoreButtons = document.querySelectorAll(selectors.loadMoreButton);
  if (loadMoreButtons.length > 0) {
    loadMoreButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        responseBuffer = [];
        loadProducts(button);
      });
    });
  }

  // Handle infinite scroll (if enabled)
  if (settings.type === 'infinite-scroll') {
    const progressSentinel = document.querySelector(selectors.sentinel);
    const loadNextButton = document.querySelector(selectors.loadNext);

    const sentinelObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio === 0) {
          return;
        }

        observer.unobserve(progressSentinel);

        if (!requestPending) {
          requestPending = true;
          loadProducts(loadNextButton, false);
        }
      });
    });

    const listObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!(entry.intersectionRatio > 0 && entry.intersectionRatio < 1)) {
          return;
        }

        loadNextButton.classList.add(classes.btnLoading);
        loadNextButton.textContent = theme.strings.pagination.loading;
        loadNextButton.blur();
        insertProducts(loadNextButton, progressSentinel, sentinelObserver);
      });
    });

    if (loadNextButton) {
      sentinelObserver.observe(progressSentinel);
      listObserver.observe(loadNextButton);
    }
  }

  async function loadProducts(button, insertAlso = true) {
    if (!button) {
      return;
    }

    if (insertAlso) {
      button.classList.add(classes.btnLoading);
      button.textContent = theme.strings.pagination.loading;
      button.blur();
    }

    const url = button.getAttribute('href');
    const urlToLoad = new URL(url);

    urlToLoad.searchParams.set('section_id', sectionID);

    try {
      const response = await fetch(urlToLoad);
      if (response.ok === false) {
        throw new Error('Load more products response was not OK');
      }

      const content = await response.text();

      responseBuffer = responseBuffer.concat(content);

      requestPending = false;

      if (insertAlso) {
        insertProducts(button);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  function insertProducts(button, progressSentinel, sentinelObserver) {
    const isLoadNext = button.hasAttribute(attributes.loadNext);
    const isLoadPrev = button.hasAttribute(attributes.loadPrev);
    const isInfiniteScrollLoad = isLoadNext && settings.type === 'infinite-scroll';

    while (responseBuffer.length > 0) {
      const content = responseBuffer.shift();

      const parser = new DOMParser();
      const container = parser.parseFromString(content, 'text/html');

      const gridFetched = container.querySelector(selectors.grid);
      const itemsFetched = container.querySelectorAll(selectors.gridItem);

      const url = button.getAttribute('href');
      const urlToLoad = new URL(url);
      const pageToLoad = parseInt(urlToLoad.searchParams.get('page'), 10);

      let newLoadBtn = container.querySelector(selectors.loadNext);
      if (isLoadPrev) {
        newLoadBtn = container.querySelector(selectors.loadPrev);
      }

      if (itemsFetched.length > 0) {
        itemsFetched.forEach((item) => {
          item.classList.add(classes.isNew);
        });
      }

      if (isLoadNext) {
        grid.insertAdjacentHTML('beforeend', gridFetched.innerHTML);
      } else {
        grid.insertAdjacentHTML('afterbegin', gridFetched.innerHTML);
      }

      const newGridItems = grid.querySelectorAll(selectors.isNew);
      if (newGridItems.length > 0) {
        // If collection or search page
        if (grid.hasAttribute(attributes.resultsGrid)) {
          const newImages = grid.querySelectorAll(`${selectors.isNew} img`);
          const selectedLayoutView = window.sessionStorage.getItem('resultsLayoutView');

          if (selectedLayoutView === 'alt') {
            newImages.forEach((image) => {
              image.sizes = grid.dataset.imageSizesAlt;
            });
          }
        }

        newGridItems.forEach((newGridItem) => {
          newGridItem.classList.remove(classes.isNew);
        });
      }

      history.replaceState({}, '', url);
      productsViewedNo += itemsFetched.length;

      if (progressViewedElem) {
        progressViewedElem.textContent = productsViewedNo;
      }

      if (progressBarElem) {
        const width = (productsViewedNo * 100) / settings.items_total;
        progressBarElem.style.width = `${width}%`;
      }

      if (isLoadNext && pageToLoad === settings.number_of_pages) {
        button.classList.add(classes.hide);
        return;
      }

      if (isLoadPrev && pageToLoad === 1) {
        pagination.parentNode.classList.add(classes.hide);
        return;
      }

      button.setAttribute('href', newLoadBtn.href);
    }

    if (isInfiniteScrollLoad && progressSentinel && sentinelObserver) {
      sentinelObserver.observe(progressSentinel);
    }

    button.classList.remove(classes.btnLoading);
    if (isLoadNext) {
      button.textContent = theme.strings.pagination.loadMore;
    } else {
      button.textContent = theme.strings.pagination.loadPrevious;
    }
  }
}

export default initPagination;
